module.exports = __webpack_public_path__ + "6d051aed9684ad4c666981398ac39650.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/people.png
// module id = 549
// module chunks = 0